import { useState } from 'react';

import Link from 'next/link';

import Notification from '../components/notification';

import useForgotPassword from '@/features/auth/hooks/useForgotPassword';

export default function ForgotPassword() {
  const [isSend, setSend] = useState(false);
  const { handleChangeValue, user, forgotPassword } = useForgotPassword();

  const LoginHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    forgotPassword();
    setSend(true);
  };

  return (
    <div className="h-[100vh]">
      <Notification />
      <div className="flex min-h-full">
        <div className="bg-primary-400 relative hidden w-0 flex-1 text-center text-white lg:block">
          <img
            className="mx-auto mt-20 object-cover"
            src="/ilustrations/Frame 48096039.png"
            alt=""
          />
          <h2 className="mt-6 text-3xl font-bold tracking-tight">Dialox</h2>
          <p className="mx-auto mt-6 max-w-lg">
            Escalating your service more professional in a single dashboard and
            help you achieve a good customer experience that brings a good
            impact for your business.
          </p>
        </div>
        <div className="flex flex-1 items-center">
          <div className="mx-auto w-full max-w-lg">
            {isSend && (
              <>
                <img
                  className="mx-auto object-cover"
                  src="/ilustrations/undraw_opened_re_i38e 1.png"
                  alt=""
                />

                <div className="text-center">
                  <h2 className="mt-6 text-3xl font-bold tracking-tight text-neutral-800">
                    Reset Password Sent
                  </h2>
                  <p className="mt-5 text-base text-gray-600">
                    We’ve sent an email to{' '}
                    <span className="font-bold">{user.email}</span> with a link
                    to reset your password
                  </p>
                </div>
                <Link href="/" className="text-primary-400 font-bold">
                  <button
                    type="submit"
                    className="bg-primary-100 text-primary-400 hover:bg-primary-300 mt-8 flex w-full justify-center rounded-md py-2 px-3 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-300"
                  >
                    Login
                  </button>
                </Link>
              </>
            )}

            {!isSend && (
              <>
                <div className="text-center">
                  <h2 className="mt-6 text-3xl font-bold tracking-tight text-neutral-800">
                    Forgot Password
                  </h2>
                  <p className="mt-5 text-base text-gray-600">
                    Dialox will email you a link to reset your password
                  </p>
                </div>
                <div className="mt-8">
                  <div className="mt-6">
                    <form onSubmit={LoginHandler} className="space-y-6">
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Email
                        </label>
                        <div className="mt-2">
                          <input
                            placeholder="Input email"
                            name="email"
                            type="email"
                            required
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            value={user.email}
                            onChange={handleChangeValue}
                          />
                        </div>
                      </div>

                      <div>
                        <button
                          type="submit"
                          className="bg-primary-100 text-primary-400 hover:bg-primary-300 flex w-full justify-center rounded-md py-2 px-3 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-300"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
